// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2537":"dba00223","8498":"19cfb5c9","9524":"5ad1eafa"}[chunkId] + ".chunk.css";
};